/**
 * 基础配置
 */
const BASE_CONFIG = {
  dev: {},
  fat: {},
  stage: {},
  prod: {},
};

/**
 * 定义服务端 Apollo 相关业务配置
 * ⚠️ 请勿声明密钥相关变量
 */
const SERVER_SIDE_CONFIG = ["NEXT_PUBLIC_DEPLOY_ENV", "NEXT_ICONFONT_VERSION"];

const SERVER_SIDE_ENV_CONFIG_KEY = "__SERVER_SIDE_ENV_CONFIG_INJECT";

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function getProcessEnv() {
  // eslint-disable-next-line no-undef
  const p = Reflect.get(globalThis, "process");
  return p?.env || {};
}

function getServerSideEnvVariables() {
  if (isBrowser()) {
    return {};
  }
  return SERVER_SIDE_CONFIG.reduce((acc, key) => {
    acc[key] = getProcessEnv()[key];
    return acc;
  }, {});
}

function inferEnvFromHostname(hostname) {
  if (!hostname) return "prod";
  if (hostname.includes("localhost")) return "fat";
  if (hostname.includes("dev")) return "dev";
  if (hostname.includes("fat")) return "fat";
  if (hostname.includes("stage")) return "stage";
  return "prod";
}

function getRuntimeEnv() {
  if (!isBrowser()) {
    return getProcessEnv().NEXT_PUBLIC_DEPLOY_ENV ?? "prod";
  }
  const env = window?.[SERVER_SIDE_ENV_CONFIG_KEY]?.NEXT_PUBLIC_DEPLOY_ENV;
  return env || inferEnvFromHostname(window.location?.hostname);
}

function getRuntimePayload() {
  if (isBrowser()) {
    return window?.[SERVER_SIDE_ENV_CONFIG_KEY] || {};
  }
  return getServerSideEnvVariables();
}

function getConfig() {
  const env = getRuntimeEnv();
  const base = BASE_CONFIG[env] || {};
  const runtime = getRuntimePayload();
  return { ...base, ...runtime };
}

module.exports = {
  get ENV() {
    return getRuntimeEnv();
  },
  getEnv() {
    return getRuntimeEnv();
  },
  get config() {
    return getConfig();
  },
  getConfig,
  getServerSideEnvVariables,
  SERVER_SIDE_ENV_CONFIG_KEY,
};
